import React, { Component } from "react";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import { parseDDMMYYYY } from "../../../utils/helpers.utils";

import Icon from "../../icon";

class DateRange extends Component {
    constructor(props) {
        super(props);
        this.state = {
          startDate: null,
          endDate: null,
        };
        this.datePickerRef = React.createRef();
        this.datePickerClick = null;
    }

        handleIconClick = () => {
            if (this.datePickerRef.current) {
                this.datePickerClick();
            }
        };

      datePickerOnChange = (dates) => {
          const { dateOnly, onChange } = this.props;
          const [start, end] = dates;

          const startDt = dateOnly && start ? new Date(`${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()}`) : start;
          const endDt = dateOnly && end ? new Date(`${end.getFullYear()}-${end.getMonth() + 1}-${end.getDate()}`) : end;
          this.setState({endDate:endDt,startDate:startDt})
          onChange([startDt, endDt]);
      }

      handleInputField=(e)=>{
        const inputValue = e.target.value;
        if (inputValue === "") {
            this.props.onChange([null, null]);
        }
      }

      handleBlur = (e) => {

          const { activeDateFormat } = this.props.adminSetting
          const inputValue = e?.target?.value || "";
          const dates = inputValue.split(/\s*-\s*/).map(d => d.trim());

          const { onChange } = this.props;
          const { startDate, endDate } = this.state;

          var newStartDate = startDate == null ? this.props.startDate : startDate;
          var newEndDate = endDate == null ? this.props.endDate : endDate;

          if (dates.length < 2) {
              if (newStartDate && !endDate) {
                  onChange([newStartDate, newStartDate]);
              }

              if (!this.isValidDate(newStartDate) || !this.isValidDate(newEndDate)) {
                  this.setState({ newStartDate: null, newEndDate: null });
                  onChange([null, null]);
              }
          }

          const [startStr, endStr] = dates;
          let start;
          let end;

          if (activeDateFormat.Name === "DD/MM/YYYY" && startStr !== "") {
            start = parseDDMMYYYY(startStr);
            end = parseDDMMYYYY(endStr);

            if (!this.isValidDate(start) || !this.isValidDate(end)) {
                this.setState({ newStartDate: null, endDate: null });
                onChange([null, null]);
            } else if (end < start) {
                onChange([start, start]);
            } else {
                onChange([start, end]);
            }
        }
        else {
            start = new Date(startStr);
            end = new Date(endStr);

            if (!isNaN(start.getTime()) && !isNaN(end.getTime())) {
                if (!this.isValidDate(start) || !this.isValidDate(end)) {
                    this.setState({ newStartDate: null, endDate: null });
                    onChange([null, null]);
                } else if (!end || end < start) {
                    onChange([start, start]);
                } else if ([start && end]) {
                    onChange([start, end]);
                }
            }
        }
        

          
      }

      isValidDate = (date) => {
          return date instanceof Date && !isNaN(date);
      }

      render() {
      
        const {startDate, endDate, label, onChange, placeholder, requiredField, dateRangeWrapperClass, isDisable} = this.props
        const { activeDateFormat } = this.props.adminSetting;
        var disableClass = isDisable ? "disabled" : ""; 
          const CustomInput = React.forwardRef(({ value, onClick, onChange, onHandleBlur, onCloseCalendar }, ref) => {
              this.datePickerClick = onClick;
              const handleOnBlur = (e) => {
                  this.handleBlur(e);
              }

              const handleKeyDown = (e) => {
                  if (e.key === 'Enter') {
                      e.preventDefault();
                      e.target.blur();
                      if (onCloseCalendar) onCloseCalendar();
                  }

              };
              return (
                  <input
                      type="text"
                      disabled={isDisable}
                      className="form-control"
                      value={value}
                      placeholder={!isDisable ? placeholder : ''}
                      onBlur={handleOnBlur}
                      onClick={onClick}
                      ref={ref}
                      onChange={onChange}
                      onKeyDown={handleKeyDown}
                  />
              )
          });
        return (
            <div className={`date-picker-container ${disableClass} ${dateRangeWrapperClass} ${requiredField ? "required":""} date-range-container`}>    
            <div className="custom-input-label">{label}</div>  
                <div className="date-picker__input-container">  
                    <DatePicker
                        ref={this.datePickerRef}
                        selectsRange={[startDate, endDate]}
                        startDate={startDate}             
                        endDate={endDate}
                        onChange={this.datePickerOnChange}
                        onCalendarClose={this.handleBlur}
                        placeholderText={label}
                        dateFormat={activeDateFormat.CSFormat}
                        customInput={
                            <CustomInput
                                onChange={this.handleInputField}
                                onHandleBlur={this.handleBlur}
                                onCloseCalendar={() => {
                                    if (this.datePickerRef.current) {
                                        this.datePickerRef.current.setOpen(false);
                                    }
                                }}
                            />}
                        disabled={isDisable}
                    />
                    <Icon
                        customClassName="icon-left"
                        name="calendar-days"      
                        size="25px"
                        containerClass="calendar-icon"
                        onClick={this.handleIconClick}
                    />
                </div>
            </div>
        );
      }
}

export default connect(
    state => {
        const { adminSetting } = state;

        return {
            adminSetting
        };
    }
)(DateRange)